export default "__VITE_ASSET__JMv3zgTZ__"